import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root",
})
export class SolicitanteApiService {
  
  private SERVER_URL = environment.api;

  constructor(private httpClient: HttpClient) {
  }

  datosSolicitante(suministro: number, tipoDocumento: string, numeroDocumento: string ){
    return this.httpClient.get<any>(this.SERVER_URL + `/datos/solicitante/${suministro}/${tipoDocumento}/${numeroDocumento}`);
  }

}
